<script lang="ts">
  /**
   *
   * Button.svelte
   *
   * Desc : Lib. Button svelte
   *
   * Author : Dmytro Teliakovskyi
   *
   * Project : cocolake
   *
   */

   
  export let type: string = "primary";
</script>

<button type="button" class={type} on:click|preventDefault>
  <slot />
</button>

<style lang="scss">
  .primary {
    background: #36f778;
    color: #0a0a0a;

    &--outline {
      color: #0a0a0a;
      border: 1px solid #0a0a0a;
    }
  }
  .secondary {
    background: #0a0a0a;

    &--outline {
      color: #0a0a0a;
      border: 1px solid #0a0a0a;
    }
  }
  .cancel {
    background: #c53030;

    &--outline {
      color: #c53030;
      border: 1px solid #c53030;
    }
  }
  button {
    cursor: pointer;
    padding: 0.6rem 1.2rem;
    border-radius: 6px;
    border: 1px solid transparent;
    color: #fdfefe;
    background: #fdfefe;
    font-size: 1.4rem;
    font-weight: bold;
    box-shadow: none;
    &:focus-visible { outline: 2px solid currentColor; outline-offset: 3px; }
  }
</style>
